import OpenSourceLibraries from '../../scenes/OpenSourceLibraries';

export default OpenSourceLibraries;
